var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataList1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.06,
    height: 22.51,
    viewBox: "0 0 20.06 22.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e4522f;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-data-list-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18 11.29 18.16 11.37 18.16 6.16 18 6 9.95 0 1.9 6 1.9 11.29 9.95 5.21 18 11.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.9 22.35 20.06 22.51 20.06 16.03 19.9 15.87 9.95 8.37 0 15.87 0 22.35 9.95 14.93 19.9 22.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataList1);
export default __webpack_public_path__ + "static/media/icon-data-list-1.3ccf90db2c796922776f6d216fc14b53.svg";
export { ForwardRef as ReactComponent };